import React, { useEffect, useState } from "react";
import DropDown from "../../common/SearchableSelect";
import Modal from "./modal";
import requestUtil from "../../../helpers/requestUtil";
import useConfiguration from "../../../hooks/useConfiguration";
import * as Toasts from "../../common/Toastify";
import Spinner from "../../common/Spinner/spinner";
import { useDispatch, useSelector } from "react-redux";
import { getAccountTypeOptions } from "../../Login/action";
const initialBankInfoState = {
  bankName:"",
  bankAddress:"",
  accountHolderName:"",
  bankAccountNumber:"",
  routingNumber:"",
  accountType:"",
  bankAccountId:0,
  locationId:null,
  paymentMode:1
};

const BankInfoModal = ({showBankInfoModal,updateBankInfoModal}) => {
  const config = useConfiguration();
  const dispatch = useDispatch();
  const accountTypesMaster = useSelector(store => store?.login?.accountTypesMaster)
  const [isLoading,setIsLoading] = useState(false);
  const [bankInfoDetails,setBankInfoDetails] = useState(initialBankInfoState);
  const [errorInfo,setErrorInfo] = useState({});
// validation
const validateBankInfo = () => {
  let errorObj = {};
  if(!bankInfoDetails.bankName){
    errorObj["bankName"] = 'This field is required';
  }
  if(!bankInfoDetails.accountHolderName){
    errorObj["accountHolderName"] = 'This field is required';
  }
  if(!bankInfoDetails.bankAccountNumber){
    errorObj["bankAccountNumber"] = 'This field is required';
  }
  if(!bankInfoDetails.routingNumber){
    errorObj["routingNumber"] = 'This field is required';
  }
  if(!bankInfoDetails.accountType){
    errorObj["accountType"] = 'This field is required';
  }
  return errorObj;
}
  // APIHandler
  const getBankInfo = async(url) => {
    try {
      setIsLoading(true);
      const bankDetails = await requestUtil(url);
      return bankDetails;
    } catch (error) {
      return null;
    } finally {
      setIsLoading(false)
    }
  };
  const postBankDetails = async({url,bankInfo}) => {
    try {
      setIsLoading(true);
      const postBankD = await requestUtil(url,"POST",{...bankInfo});
      Toasts.success(postBankD?.message);
      return postBankD;
    } catch (error) {
      Toasts.error(error);
      return error;
    } finally {
      setIsLoading(false)
    }
  }
  
  const dropdownHandler = target => {
    const {name,value} = target;
    setBankInfoDetails(prev => ({...prev,[name]:value}));
  };
  const inputHandler = e => {
    const {name,value} = e.target;
    setBankInfoDetails(prev => ({...prev,[name]:value}));
  };
  const closeHandler = () => {
    updateBankInfoModal(prev => ({...prev,status:false,locationId:null}))
    setBankInfoDetails(initialBankInfoState);
  };
  const saveHandler = async() => {
    const errorObj = validateBankInfo();
    console.log({errorObj:Object.values(errorObj)});
    if(Object.values(errorObj)?.length > 0){
      setErrorInfo(errorObj);
      return;
    }
    await postBankDetails({url:`${config.baseUrl}/${showBankInfoModal?.postURL}`, bankInfo:{...bankInfoDetails,accountType:bankInfoDetails?.accountType?.id,locationId:showBankInfoModal?.location?.id ?? null}})
    updateBankInfoModal(prev => ({...prev,status:false, locationId:null}))
    setBankInfoDetails(initialBankInfoState)
  };
  console.log({accountTypesMaster});
  useEffect(async () => {
    if(!config.baseUrl) return;
    if(accountTypesMaster?.length ===0){
      dispatch(getAccountTypeOptions({baseURL:config.baseUrl}))
    } 
    if( accountTypesMaster?.length > 0){
      if(showBankInfoModal?.getURL){
      const bankDetails = await getBankInfo(`${config.baseUrl}/${showBankInfoModal?.getURL}`);
      const payload = {
        bankName:bankDetails?.bankName ?? initialBankInfoState.bankName,
        bankAddress:bankDetails?.bankAddress ?? initialBankInfoState.bankAddress,
        accountHolderName:bankDetails?.accountHolderName ?? initialBankInfoState.accountHolderName,
        bankAccountNumber:bankDetails?.bankAccountNumber ?? initialBankInfoState.bankAccountNumber,
        routingNumber:bankDetails?.routingNumber ?? initialBankInfoState.routingNumber,
        accountType:accountTypesMaster?.find(acc => +acc?.id === +bankDetails?.accountType) ?? initialBankInfoState.accountType,
        bankAccountId:bankDetails?.bankAccountId ?? initialBankInfoState.bankAccountId,
        locationId:bankDetails?.locationId ?? initialBankInfoState.locationId,
        paymentMode:bankDetails?.paymentMode ?? initialBankInfoState.paymentMode
      };
        setBankInfoDetails((prev) => ({ ...prev,...payload}));
      } else if(showBankInfoModal?.location?.id){
        setBankInfoDetails((prev) => ({ ...prev,locationId:showBankInfoModal?.location?.id}))
      }
    }
  },[config.baseUrl,showBankInfoModal?.location?.id,accountTypesMaster?.length])
  return (
    <>
       {isLoading  && <Spinner />}
      <Modal
        showHide={closeHandler}
        label={`${showBankInfoModal?.location?.name ? `${showBankInfoModal?.location?.name} - `:''} Bank Account Details`}
        size={"lg"}
        center={true}
        saveFunction={saveHandler}
      >
        <div className="">
          <form
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2,minmax(0,1fr))",
              gap: "2rem",
            }}
          >
            <section>
              <label htmlFor="bankName">
                Bank Name <span className="required">*</span>
              </label>
              <input
                name="bankName"
                id="bankName"
                type="text"
                className="form-control "
                // placeholder="Enter Incentive Amount"
                value={bankInfoDetails?.bankName}
                onChange={inputHandler}
              />
               {errorInfo?.bankName ?  <div className="invalid-input">{errorInfo?.bankName}</div> : null}
            </section>
            <section>
              <label htmlFor="bankAddress">Bank Address</label>
              <input
                name="bankAddress"
                id="bankAddress"
                type="text"
                className="form-control "
                // placeholder="Enter Incentive Amount"
                value={bankInfoDetails?.bankAddress}
                onChange={inputHandler}
              />
            </section>
            <section>
              <label htmlFor="accountHolderName">
                Name of the Account Holder <span className="required">*</span>
              </label>
              <input
                name="accountHolderName"
                id="accountHolderName"
                type="text"
                className="form-control "
                value={bankInfoDetails?.accountHolderName}
                // placeholder="Enter Incentive Amount"
                onChange={inputHandler}
              />
              {errorInfo?.accountHolderName ?  <div className="invalid-input">{errorInfo?.accountHolderName}</div> : null}
            </section>
            <section>
              <label htmlFor="accountNumber">
                Bank Account Number <span className="required">*</span>
              </label>
              <input
                name="bankAccountNumber"
                id="bankAccountNumber"
                type="text"
                className="form-control "
                // placeholder="Enter Incentive Amount"
                value={bankInfoDetails?.bankAccountNumber}
                onChange={inputHandler}
              />
              {errorInfo?.bankAccountNumber ?  <div className="invalid-input">{errorInfo?.bankAccountNumber}</div>:null}
            </section>
            <section>
              <label htmlFor="routingNumber">
                Routing Number <span className="required">*</span>
              </label>
              <input
                name="routingNumber"
                id="routingNumber"
                type="text"
                className="form-control "
                // placeholder="Enter Incentive Amount"
                value={bankInfoDetails?.routingNumber}
                onChange={inputHandler}
              />
              {errorInfo?.routingNumber ?  <div className="invalid-input">{errorInfo?.routingNumber}</div>:null}
            </section>
            <section>
              <DropDown
                name={"accountType"}
                label={"Type of Account"}
                star={"*"}
                id={"accountType"}
                divClass={"w-100"}
                value={bankInfoDetails.accountType ? [bankInfoDetails.accountType] : []}
                options={accountTypesMaster}
                multiple={false}
                updateValue={dropdownHandler}
                isObject={true}
              />
              {errorInfo?.accountType ?  <div className="invalid-input">{errorInfo?.accountType}</div>:null}
            </section>
          </form>
        </div>
      </Modal>
    </>
  );
};

export default BankInfoModal;
